// Shared catalog display names used by the document library and Finance.
// Preserve the agreed CFA wording without changing stored document codes.
const CLIENT_FUNDING_AGREEMENT_LABEL = "Client Funding Agreement";
function paymentDocumentTypeLabel(code, catalogLabel) {
  return code === "funding_agreement" ? CLIENT_FUNDING_AGREEMENT_LABEL : catalogLabel || code;
}
module.exports = { CLIENT_FUNDING_AGREEMENT_LABEL, paymentDocumentTypeLabel };
